import { Module } from "wrapper6";

export default class MttProductGallery extends Module {
  ready() {}
}
